import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
    routes: [{ //账号
            path: '/account',
            name: 'account',
            component: resolve => require(['@/views/account/index'], resolve),
            redirect: '/account/register',
            children: [{
                    path: '/account/register',
                    name: 'register',
                    component: resolve => require(['@/views/account/register'], resolve),
                    meta: {
                        name: ['注册账号'],
                    }
                },
                {
                    path: '/account/findAccount',
                    name: 'findAccount',
                    component: resolve => require(['@/views/account/findAccount'], resolve),
                    meta: {
                        name: ['找回账号'],
                    }
                }
            ]
        },
        { //主体
            path: '/',
            name: 'index',
            component: resolve => require(['@/views/template/index'], resolve),
            redirect: '/index', //主体显示默认显示
            // 子
            children: [{ //首页
                    path: '/index',
                    name: 'index',
                    component: resolve => require(['@/views/index/home'], resolve),
                    redirect: '/index/index', //系统设置默认显示
                    children: [{
                            path: '/index/index',
                            name: 'index',
                            component: resolve => require(['@/views/index/index'], resolve),
                            meta: {
                                name: ['首页'],
                                sign: '1',
                            }
                        },
                        {
                            path: '/index/articleDetails',
                            name: 'indexArticleDetails',
                            component: resolve => require(['@/views/index/articleDetails'], resolve),
                            meta: {
                                name: ['首页', '文章详情'],
                                sign: '1',
                            }
                        }
                    ]
                },
                {
                    path: '/healthCare', //医疗方案
                    name: 'healthCare',
                    component: resolve => require(['@/views/healthCare/index'], resolve),
                    redirect: '/healthCare/caseList', //系统设置默认显示
                    children: [{
                        path: '/healthCare/caseList',
                        name: 'healthCareList',
                        component: resolve => require(['@/views/healthCare/caseList'], resolve),
                        meta: {
                            name: ['医疗方案', '列表'],
                            sign: '2',
                        }
                    }, {
                        path: '/healthCare/caseDetailResult',
                        name: 'healthCareDetailResult',
                        component: resolve => require(['@/views/healthCare/caseDetailResult'], resolve),
                        meta: {
                            name: ['医疗方案', '详情'],
                            sign: '2',
                        }
                    }, {
                        path: '/healthCare/treatmentPlan',
                        name: 'healthCareTreatmentPlan',
                        component: resolve => require(['@/views/healthCare/treatmentPlan'], resolve),
                        meta: {
                            name: ['医疗方案', '治疗套餐'],
                            sign: '2',
                        }
                    }]
                },
                {
                    path: '/service', //专业服务
                    name: 'service',
                    component: resolve => require(['@/views/service/index'], resolve),
                    redirect: '/service/service',
                    children: [{
                        path: '/service/service',
                        name: 'serviceIndex',
                        component: resolve => require(['@/views/service/service'], resolve),
                        meta: {
                            name: ['专业服务'],
                            sign: '3',
                        }
                    }]
                },
                {
                    path: '/charge', //收费标准
                    name: 'charge',
                    component: resolve => require(['@/views/charge/index'], resolve),
                    redirect: '/charge/charge',
                    children: [{
                        path: '/charge/charge',
                        name: 'chargeIndex',
                        component: resolve => require(['@/views/charge/charge'], resolve),
                        meta: {
                            name: ['收费标准'],
                            sign: '4',
                        }
                    }]
                },
                {
                    path: '/about', //关于我们
                    name: 'about',
                    component: resolve => require(['@/views/about/index'], resolve),
                    redirect: '/about/about',
                    children: [{
                        path: '/about/about',
                        name: 'aboutIndex',
                        component: resolve => require(['@/views/about/about'], resolve),
                        meta: {
                            name: ['关于我们'],
                            sign: '5',
                        }
                    }]
                },
                {
                    path: '/userCenter', //用户中心
                    name: 'userCenter',
                    component: resolve => require(['@/views/userCenter/index'], resolve),
                    redirect: '/userCenter/template',
                    children: [{
                        path: '/userCenter/template',
                        name: 'userTemplate',
                        component: resolve => require(['@/views/userCenter/template'], resolve),
                        redirect: '/userCenter/myTest',
                        meta: {
                            name: ['用户中心模板'],
                            sign: '6',
                        },
                        children: [{
                                path: '/userCenter/myTest',
                                name: 'userMyTest',
                                component: resolve => require(['@/views/userCenter/myTest'], resolve),
                                meta: {
                                    name: ['用户中心', '我的测试'],
                                    sign: '6',
                                    userSign: 'user'
                                }
                            },
                            {
                                path: '/userCenter/testResult',
                                name: 'userMyTestResult',
                                component: resolve => require(['@/views/userCenter/testResult'], resolve),
                                meta: {
                                    name: ['用户中心', '测试结果'],
                                    sign: '6',
                                    userSign: 'user'
                                }
                            },
                            {
                                path: '/userCenter/accountInfo',
                                name: 'userAccountInfo',
                                component: resolve => require(['@/views/userCenter/accountInfo'], resolve),
                                meta: {
                                    name: ['用户中心', '账户信息'],
                                    sign: '6',
                                    userSign: 'userInfo'
                                }
                            },
                            {
                                path: '/userCenter/editInfo',
                                name: 'userEditInfo',
                                component: resolve => require(['@/views/userCenter/editInfo'], resolve),
                                meta: {
                                    name: ['用户中心', '修改信息'],
                                    sign: '6',
                                    userSign: 'userInfo'
                                }
                            },
                            {
                                path: '/userCenter/price',
                                name: 'userPrice',
                                component: resolve => require(['@/views/userCenter/price'], resolve),
                                meta: {
                                    name: ['用户中心', '账户充值'],
                                    sign: '6',
                                    userSign: 'pay'
                                }
                            },
                            {
                                path: '/userCenter/pay',
                                name: 'userPay',
                                component: resolve => require(['@/views/userCenter/pay'], resolve),
                                meta: {
                                    name: ['用户中心', '账户支付'],
                                    sign: '6',
                                    userSign: 'pay'
                                }
                            }
                        ]
                    }, ]
                },
                {
                    path: '/drug', //药品信息
                    name: 'drug',
                    component: resolve => require(['@/views/drug/index'], resolve),
                    redirect: '/drug/drugList',
                    children: [{
                        path: '/drug/drugList',
                        name: 'drugList',
                        component: resolve => require(['@/views/drug/drugList'], resolve),
                        meta: {
                            name: ['药品信息', '列表'],
                            sign: '7',
                        }
                    }, {
                        path: '/drug/drugDetail',
                        name: 'drugDetail',
                        component: resolve => require(['@/views/drug/drugDetail'], resolve),
                        meta: {
                            name: ['药品信息', '详情'],
                            sign: '7',
                        }
                    }]
                },
                {
                    path: '/shopping', //购物车
                    name: 'shopping',
                    component: resolve => require(['@/views/shopping/index'], resolve),
                    redirect: '/shopping/cart',
                    children: [{
                        path: '/shopping/cart',
                        name: 'cart',
                        component: resolve => require(['@/views/shopping/cart'], resolve),
                        meta: {
                            name: ['购物车', '列表'],
                            sign: '8',
                        }
                    }]
                },
            ]
        }
    ]
})